import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { AccelaControlType } from 'src/app/modules/shared/model/accelaControl.model';

@Component({
  selector: 'aca-page-layout-display',
  templateUrl: './page-layout-display.component.html',
  styleUrls: ['./page-layout-display.component.css']
})
export class PageLayoutDisplayComponent implements OnInit {

  @Input() controlGroup: UntypedFormGroup;

  @Output() controlOnBlur: EventEmitter<UntypedFormControl> = new EventEmitter<UntypedFormControl>();
  @Output() onchkChange = new EventEmitter<boolean>();
  controlTypes = AccelaControlType;

  constructor(private store: Store<AppState>) { }

  ngOnInit(): void {
  }

  //Unsort the elements by keyvalue in FormGroup
  unsorted() {
    return 0;
  }

  onFocusChange(formRef: UntypedFormControl){
    this.controlOnBlur.emit(formRef);
  }

  chkstatus(newItem: boolean) {
    this.onchkChange.emit(newItem);
  }
}
